var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgECarCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.9868,
    r: 19,
    fill: "#539D77"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6266 13.4302C24.4884 13.0226 24.1015 12.7324 23.6455 12.7324H16.0455C15.5895 12.7324 15.2095 13.0226 15.0644 13.4302L13.6273 17.5688V23.0961C13.6273 23.4761 13.9382 23.787 14.3182 23.787H15.0091C15.3891 23.787 15.7 23.4761 15.7 23.0961V22.4051H23.991V23.0961C23.991 23.4761 24.3019 23.787 24.6819 23.787H25.3728C25.7528 23.787 26.0637 23.4761 26.0637 23.0961V17.5688L24.6266 13.4302ZM16.0455 20.3324C15.472 20.3324 15.0091 19.8695 15.0091 19.2961C15.0091 18.7226 15.472 18.2597 16.0455 18.2597C16.619 18.2597 17.0819 18.7226 17.0819 19.2961C17.0819 19.8695 16.619 20.3324 16.0455 20.3324ZM23.6455 20.3324C23.072 20.3324 22.6091 19.8695 22.6091 19.2961C22.6091 18.7226 23.072 18.2597 23.6455 18.2597C24.219 18.2597 24.6819 18.7226 24.6819 19.2961C24.6819 19.8695 24.219 20.3324 23.6455 20.3324ZM15.0091 16.8779L16.0455 13.7688H23.6455L24.6819 16.8779H15.0091Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.391 25.8598H19.1546V24.478L23.3001 26.5508H20.5364V27.9326L16.391 25.8598Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECarCharging);
export default __webpack_public_path__ + "static/media/e-car-charging.0daf1f1908b5d5a9c1adb3ee4ee192db.svg";
export { ForwardRef as ReactComponent };